import React, { useEffect, useCallback } from 'react'
// Views
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import { GoogleReCaptcha, useGoogleReCaptcha } from 'react-google-recaptcha-v3'

function ReCaptchaView(props) {
  const { executeRecaptcha } = useGoogleReCaptcha()

  const handleReCaptchaVerify = useCallback(async () => {
    if (!executeRecaptcha) {
      return
    }

    const token = await executeRecaptcha('validate_captcha')
    //
    props.receiveToken(token)
    // Do whatever you want with the token
    // eslint-disable-next-line
  }, [executeRecaptcha])

  useEffect(() => {
    handleReCaptchaVerify()
  }, [handleReCaptchaVerify])

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', mt: 0 }}>
      <Box component='form'>
        <Typography
          component='span'
          sx={{
            display: '-webkit-box',
            overflow: 'hidden',
            WebkitBoxOrient: 'vertical'
          }}
        >
          <Typography
            variant='body2'
            sx={{
              display: 'inline'
            }}
          >
            {'This site is protected by reCAPTCHA and the Google '}
          </Typography>
          <Typography
            variant='a'
            href='https://policies.google.com/privacy'
            sx={{
              display: 'inline',
              color: theme => theme.palette.primary.main
            }}
          >
            {`Privacy Policy`}
          </Typography>
          <Typography
            variant='body2'
            sx={{
              display: 'inline'
            }}
          >
            {' and '}
          </Typography>
          <Typography
            variant='a'
            href='https://policies.google.com/terms'
            sx={{
              display: 'inline',
              color: theme => theme.palette.primary.main
            }}
          >
            {`Terms of Service`}
          </Typography>
          <Typography
            variant='body2'
            sx={{
              display: 'inline'
            }}
          >
            {' apply'}
          </Typography>
        </Typography>
      </Box>
      <Box component='form' sx={{ marginTop: 2 }}>
        <GoogleReCaptcha />
      </Box>
    </Box>
  )
}

export default ReCaptchaView
